import classNames from 'classnames';
import VibeIcon from '../VibeIcon/VibeIcon';
import viCheck from '../../icons/viCheck';
import viSubtract from '../../icons/viSubtract';
import viInformation from '../../icons/viInformation';
import { transparent } from '../../utils/ColorUtil';
import * as color from '../../sass/color.scss';
import './VibeCheckbox.scss';

function VibeCheckbox({
  className = null,
  label = null,
  name = null,
  tooltip = null,
  size = 16,
  color: checkboxColor = color.success,
  outline = false,
  rootStyle = {},
  style = {},
  indeterminate = false,
  disabled = false,
  checked = false,
  error = false,
  onChange = () => {},
}) {
  /**
   * Get the border color for the checkbox
   */
  const getBorderColor = () => {
    if (checked) {
      // Only use the custom color when checked
      return disabled
        ? transparent(checkboxColor, 50)
        : checkboxColor;
    }

    if (error) {
      return color.lightGray;
    }

    return disabled
      ? transparent(color.manatee, 50)
      : color.manatee;
  };

  /**
   * Get the background color for the checkbox
   */
  const getBackgroundColor = () => {
    if (outline) {
      return 'transparent';
    }

    if (checked) {
      return disabled
        ? transparent(checkboxColor, 50)
        : checkboxColor;
    }

    return 'transparent';
  };

  /**
   * Get the checkmark color for the checkbox
   */
  const getCheckmarkColor = () => {
    if (outline) {
      return disabled
        ? transparent(checkboxColor, 50)
        : checkboxColor;
    }

    return color.white;
  };

  const onChangeCheckbox = () => {
    if (disabled) {
      return;
    }

    onChange({
      name,
      checked: !checked,
    });
  };

  return (
    <div
      className={classNames('VibeCheckbox', className, { disabled })}
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: 8,
        ...rootStyle,
      }}
    >
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: 8,
          cursor: disabled
            ? 'default'
            : 'pointer',
        }}
        onClick={onChangeCheckbox}
      >
        <div
          className="check-item"
          style={{
            width: size,
            height: size,
            border: `1px solid ${getBorderColor()}`,
            backgroundColor: getBackgroundColor(),
            ...style,
          }}
        >
          {checked && (
            <VibeIcon
              icon={indeterminate
                ? viSubtract
                : viCheck}
              color={getCheckmarkColor()}
              size={size - 5}
            />
          )}
        </div>

        {label && (
          <div
            style={{
              fontSize: 12,
            }}
          >
            {label}
          </div>
        )}
      </div>

      {tooltip && (
        <VibeIcon
          icon={viInformation}
          color={color.manatee}
          size={16}
          tooltip={tooltip}
          tooltipProps={{
            placement: 'right',
          }}
        />
      )}
    </div>
  );
}

export default VibeCheckbox;